/**
 * The one list of ticket topics (spec docs/specs_20261102_inbox_deflection.md, W1).
 *
 * Read by prism-api (the classifier, the topic filter and the weekly counts) and
 * by the Prism inbox (the chip and the picker). A topic added here appears in
 * both. The keys are stored in `tickets.topic`, so never rename one: add a new
 * key and move the rows instead.
 *
 * The topics come from the inbox sample of 15 October to 1 November 2026.
 */

export const TOPIC_SIDE = Object.freeze({ SELLER: 'seller', BUYER: 'buyer', NONE: 'none' });

export const NOT_CUSTOMER_TOPIC = 'not_customer';

export const TICKET_TOPICS = Object.freeze([
    { key: 'price_wrong', label: 'Price looks wrong', side: TOPIC_SIDE.SELLER },
    { key: 'status', label: 'Status', side: TOPIC_SIDE.SELLER },
    { key: 'accept_decline', label: 'Accept or decline', side: TOPIC_SIDE.SELLER },
    { key: 'more_info', label: 'Adding items or more info', side: TOPIC_SIDE.SELLER },
    { key: 'box_sizes', label: 'Box sizes', side: TOPIC_SIDE.SELLER },
    { key: 'packing', label: 'Packing', side: TOPIC_SIDE.SELLER },
    { key: 'do_you_buy', label: 'Do you buy this', side: TOPIC_SIDE.SELLER },
    { key: 'booking', label: 'Booking', side: TOPIC_SIDE.SELLER },
    { key: 'how_it_works', label: 'How it works', side: TOPIC_SIDE.SELLER },
    { key: 'when_paid', label: 'When will I be paid', side: TOPIC_SIDE.SELLER },
    { key: 'labels_printer', label: 'Labels or printer', side: TOPIC_SIDE.SELLER },
    { key: 'courier_no_show', label: "Courier didn't come", side: TOPIC_SIDE.SELLER },
    { key: 'complaint', label: 'Complaint', side: TOPIC_SIDE.SELLER },
    { key: 'drop_off', label: 'Drop-off', side: TOPIC_SIDE.SELLER },
    { key: 'bank_details', label: 'Bank details', side: TOPIC_SIDE.SELLER },
    { key: 'seller_other', label: 'Selling, other', side: TOPIC_SIDE.SELLER },
    { key: 'pre_purchase', label: 'Question before buying', side: TOPIC_SIDE.BUYER },
    { key: 'offers', label: 'Offer on a listing', side: TOPIC_SIDE.BUYER },
    { key: 'returns', label: 'Return or refund', side: TOPIC_SIDE.BUYER },
    { key: 'order_status', label: 'Where is my order', side: TOPIC_SIDE.BUYER },
    { key: 'missing_parts', label: 'Missing parts', side: TOPIC_SIDE.BUYER },
    { key: 'phone_order', label: 'Ordering by phone', side: TOPIC_SIDE.BUYER },
    { key: 'buyer_other', label: 'Buying, other', side: TOPIC_SIDE.BUYER },
    { key: NOT_CUSTOMER_TOPIC, label: 'Not a customer', side: TOPIC_SIDE.NONE },
]);

const TOPICS_BY_KEY = new Map(TICKET_TOPICS.map((topic) => [topic.key, topic]));

/** True only for a key in the list above. */
export function isTicketTopic(key) {
    return typeof key === 'string' && TOPICS_BY_KEY.has(key);
}

/** The label for a key, or null for an unknown key. */
export function ticketTopicLabel(key) {
    return TOPICS_BY_KEY.get(key)?.label ?? null;
}
